import { field, json, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";
import { noopSanitizeJSON } from "../utils";

export const SanitizeJSONLocationPricing = (json: any) => {
  return json;
};

export default class PayType extends BaseModel {
  static table = "pay_types";
  @text("name") name: string;
  @text("description") description: string | null;
  @text("subtext") subtext: string | null;
  @text("logo") logo: string | null;
  @field("available") available: boolean;
  @field("internal") internal: boolean;
  @field("online_only") onlineOnly: boolean;
  @field("configuration_url") configurationUrl: string | null;
  @field("default_gateway_url") defaultGatewayUrl: string | null;
  @json("platforms", noopSanitizeJSON) platforms: string[];
  @json("channels", noopSanitizeJSON) channels: string[];
}
